import styled from 'styled-components';

import Title from '../../DashPanel/Title';

export default styled(Title)`
  display: grid;
  grid-column-gap: 1rem;
  grid-template-columns: auto auto 1fr;
`;
